import PropTypes from 'prop-types';
import React from 'react';
import LoadingPage from '../components/LoadingPage';
import Button from '../components/Button';
import HelpPopup from '../components/helpPopup/HelpPopup';
import { NBSP } from '../../constants/text';
import USER_TYPE from '../../constants/userType';

const USER_ROLE_ERROR_MESSAGE = `Please log in as a student. To return to Educator Home, click "Go${NBSP}Back".`;
const BACK_BUTTON_TEXT = 'Go Back';
const LOGOUT_BUTTON_TEXT = 'Log In as a Student';

export default class SessionTrackerView extends React.Component {
    componentDidMount() {
        // App.componentDidMount fires clearState() on landing pages, which wipes
        // userId set by AuthProvider. Re-running resolveUser here repopulates the
        // store from keycloak.tokenParsed (still held by the singleton).
        if (!this.props.userId) {
            this.props.resolveUser();
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.userId !== undefined && this.props.userId === undefined) {
            this.props.resolveUser();
        }
        if (this.props.authenticationFailed) {
            this.props.handleAuthenticationFailed();
        }
    }

    render() {
        const buttons = [
            <Button
                key="userTypeFail-logout"
                className="modal-btn"
                text={LOGOUT_BUTTON_TEXT}
                onClick={this.props.logUserOut}
                ariaLabel="Log out"
                isPrimary
            />,
            <Button
                key="userTypeFail-redirect"
                className="modal-btn"
                text={BACK_BUTTON_TEXT}
                onClick={this.props.portalRedirect}
                ariaLabel="Back"
                isSecondary
            />,
        ];

        if (this.props.userId === undefined) {
            return (
                <div>
                    <LoadingPage />
                </div>
            );
        }

        return (
            this.props.userType !== USER_TYPE.STUDENT && (
                <HelpPopup title="" problem={USER_ROLE_ERROR_MESSAGE} buttons={buttons} />
            )
        );
    }
}

SessionTrackerView.propTypes = {
    userId: PropTypes.string,
    userType: PropTypes.string,
    resolveUser: PropTypes.func.isRequired,
    logUserOut: PropTypes.func.isRequired,
    portalRedirect: PropTypes.func.isRequired,
    handleAuthenticationFailed: PropTypes.func.isRequired,

    /* These are props that are never referenced as `this.props` so they trigger lint errors */
    authenticationFailed: PropTypes.bool,
};

SessionTrackerView.defaultProps = {
    userId: undefined,
    userType: undefined,
    authenticationFailed: false,
};
